  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import FaltaService from   "@/service/v1/sigap/FaltaService"  

    
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 


    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
          
        @Prop( ) readonly turmaId!: any   
        @Prop( ) readonly cpf!: any   
         

        @authStore.Getter
		public token!: any
        
        public identificador = 1 ;   
        public url: any = "";
        public service = new FaltaService();
        public modal: any = "modal_pdf_faltas_agrupadas";
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;

        @Watch('matricula')
		dadosAtualizado(newVal: string) { 
            this.identificador++; 
		} 
  
        public gerarBoletim(){
            this.url =   null;  
            setTimeout(() => {
                this.url = this.service.getApiUrl() + `/Relatorio/GetFaltaAgrupadas/Pdf?cpf=${this.cpf != null ? this.cpf : ''}&turmaId=${this.turmaId != null ? this.turmaId : ''}&token=${this.token}`;
                this.identificador++;
            }, 2 ); 
        }

    } 
